/* KitKraft — Build-a-Bot game engine. Config comes from #kkbab-config (rendered by the section from theme settings). */
(function(){
  "use strict";
  var root = document.querySelector('.kkbab'); if(!root) return;
  var cfgEl = document.getElementById('kkbab-config');
  var CONFIG; try{ CONFIG = JSON.parse(cfgEl.textContent); }catch(e){ return; }
  var DISCOUNT_BASE = ((CONFIG.discountBase || '/') + '/').replace(/\/\/+$/,'/');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS='http://www.w3.org/2000/svg';
  var $ = function(id){ return document.getElementById(id); };

  /* ---- level design (baked; a new level ≈ 12 lines) ---- */
  var ICON={head:'⬡',body:'▣',wheel:'⬤',antenna:'⌇',sensor:'▤',arm:'▮',joint:'⬤',grip:'⊐',base:'▬',hip:'▤',leg:'▮',foot:'▬',leg6:'╱',
    cup:'☕',book:'📕',spring:'➰',prop:'✈',brick:'▩',duck:'🦆'};
  var LABEL={head:'Dome head',body:'Chassis',wheel:'Wheel',antenna:'Antenna',sensor:'Sensor bar',arm:'Arm segment',joint:'Joint',grip:'Gripper',
    base:'Heavy base',hip:'Hip',leg:'Leg',foot:'Foot',leg6:'Walking leg',
    cup:'Teacup',book:'Notebook',spring:'Loose spring',prop:'Propeller',brick:'Random brick',duck:'Rubber duck'};
  function R(id,a,x,y,w,h,o){ return {id:id,accept:a,kind:'rect',x:x,y:y,w:w,h:h,order:o}; }
  function C(id,a,x,y,r,o){ return {id:id,accept:a,kind:'circle',x:x,y:y,r:r,order:o}; }
  function E(id,a,x,y,rx,ry,o){ return {id:id,accept:a,kind:'ellipse',x:x,y:y,rx:rx,ry:ry,order:o}; }

  var LEVELS=[
    { frame:'M160 70 V86 M96 200 H224',
      slots:[ R('s_head','head',112,20,96,48), R('s_body','body',98,86,124,96), C('s_wl','wheel',82,200,24), C('s_wr','wheel',238,200,24) ],
      eyes:[[138,42],[182,42]], parts:['head','body','wheel','wheel'], decoys:[],
      bom:['Arduino Uno (compatible)','L298N motor driver','2× BO gear motor + wheel','AA battery holder','Chassis plate'] },
    { frame:'M160 30 V12 M160 76 V88 M96 200 H224',
      slots:[ R('s_ant','antenna',142,10,36,20), R('s_head','head',112,30,96,46), R('s_body','body',98,88,124,80),
              R('s_sen','sensor',108,172,104,14), C('s_wl','wheel',84,202,22), C('s_wr','wheel',236,202,22) ],
      eyes:[[138,50],[182,50]], parts:['antenna','head','body','sensor','wheel','wheel'], decoys:['spring'],
      bom:['Arduino Nano','L298N driver','2× TT motor + wheel','HC-SR04 ultrasonic sensor','Antenna wire','Battery holder'] },
    { order:true, frame:'M160 20 V270', noEyes:true,
      slots:[ R('a_base','base',112,232,96,38,0), R('a_low','arm',138,168,44,50,1), C('a_elb','joint',160,146,12,2),
              R('a_up','arm',138,86,44,46,3), C('a_wr','joint',160,64,10,4), R('a_grip','grip',134,22,52,30,5) ],
      parts:['base','arm','joint','arm','joint','grip'], decoys:['wheel','prop'],
      bom:['MG996R servo × 3','SG90 micro servo','Arm bracket set','Gripper kit','Servo driver (PCA9685)','5V 3A supply'] },
    { frame:'M160 54 V60 M132 148 H188',
      slots:[ R('b_head','head',122,12,76,42), R('b_torso','body',106,60,108,84), R('b_hl','hip',108,150,42,24), R('b_hr','hip',170,150,42,24),
              R('b_ll','leg',116,180,24,58), R('b_lr','leg',180,180,24,58), R('b_fl','foot',102,244,46,18), R('b_fr','foot',172,244,46,18) ],
      eyes:[[142,32],[178,32]], parts:['head','body','hip','hip','leg','leg','foot','foot'], decoys:['wheel','duck'],
      bom:['Arduino Nano','8× SG90 servo','Biped frame kit','Servo shield','Foot pads','7.4V LiPo + charger'] },
    { power:true, frame:'M64 116 L96 138 M52 150 H96 M64 184 L96 162 M256 116 L224 138 M268 150 H224 M256 184 L224 162',
      slots:[ E('h_body','body',160,158,80,40), R('h_head','sensor',132,84,56,26),
              C('h_l1','leg6',60,116,14), C('h_l2','leg6',48,150,14), C('h_l3','leg6',60,184,14),
              C('h_r1','leg6',260,116,14), C('h_r2','leg6',272,150,14), C('h_r3','leg6',260,184,14) ],
      eyes:[[148,150],[172,150]], parts:['body','sensor','leg6','leg6','leg6','leg6','leg6','leg6'], decoys:['wheel','brick','cup'],
      bom:['Raspberry Pi Zero 2 W','18× MG90S servo','Hexapod chassis','2× PCA9685 driver','IMU (MPU-6050)','Distance sensor','6V 5A supply'] }
  ];

  /* ---- sound + confetti ---- */
  var soundOn=true, actx=null;
  function tone(f,d,t){ if(!soundOn) return; try{ actx=actx||new (window.AudioContext||window.webkitAudioContext)(); }catch(e){ return; }
    var o=actx.createOscillator(), g=actx.createGain(); o.type=t||'sine'; o.frequency.value=f;
    g.gain.setValueAtTime(.0001,actx.currentTime); g.gain.exponentialRampToValueAtTime(.14,actx.currentTime+.01);
    g.gain.exponentialRampToValueAtTime(.0001,actx.currentTime+(d||.18));
    o.connect(g); g.connect(actx.destination); o.start(); o.stop(actx.currentTime+(d||.18)+.02); }
  function chord(){ [523,659,784,1047].forEach(function(f,i){ setTimeout(function(){tone(f,.24,'triangle');},i*70); }); }
  function burst(n){ if(reduce) return; var cols=[CONFIG.accent||'#ffab1a','#2bb7cb','#2fae6a','#7b6cf0','#e8654a'];
    for(var i=0;i<(n||30);i++){ (function(k){ var d=document.createElement('div'); d.className='kkbab-confetti';
      var x=innerWidth*(.25+Math.random()*.5), y=innerHeight*(.2+Math.random()*.15); d.style.background=cols[k%cols.length];
      document.body.appendChild(d); var dx=(Math.random()-.5)*420, dy=240+Math.random()*320, r=Math.random()*720;
      d.animate([{transform:'translate('+x+'px,'+y+'px) rotate(0)'},{transform:'translate('+(x+dx)+'px,'+(y+dy)+'px) rotate('+r+'deg)',opacity:0}],
        {duration:1100+Math.random()*700,easing:'cubic-bezier(.2,.6,.3,1)'}).onfinish=function(){d.remove();}; })(i); } }

  /* ---- drag ---- */
  function draggable(el,onDrop){
    el.addEventListener('pointerdown',function(e){
      if(el.classList.contains('placed')) return; e.preventDefault();
      if(!started){ started=true; try{ document.dispatchEvent(new CustomEvent('kk:game-start',{detail:{game:'build-a-bot'}})); }catch(err){} }
      var saved=el.getAttribute('style')||''; var r=el.getBoundingClientRect();
      var ox=e.clientX-r.left, oy=e.clientY-r.top, moved=false;
      el.classList.add('dragging');
      el.style.position='fixed'; el.style.left='0'; el.style.top='0'; el.style.margin='0'; el.style.width=r.width+'px';
      function mv(ev){ moved=true; el.style.transform='translate('+(ev.clientX-ox)+'px,'+(ev.clientY-oy)+'px)'; }
      function up(ev){ document.removeEventListener('pointermove',mv); document.removeEventListener('pointerup',up);
        el.classList.remove('dragging');
        var ok = moved ? onDrop(el,ev.clientX,ev.clientY) : false;
        el.setAttribute('style',saved); if(ok) el.classList.add('placed'); }
      mv(e); document.addEventListener('pointermove',mv); document.addEventListener('pointerup',up);
    });
  }
  function slotAt(x,y){ var l=document.elementsFromPoint(x,y); for(var i=0;i<l.length;i++){ if(l[i].classList&&l[i].classList.contains('kkb-slot')) return l[i]; } return null; }

  /* ---- state ---- */
  var svg=$('kkbab_svg'), tray=$('kkbab_tray');
  var li=0, lv=null, filled=0, need=0, wrong=0, t0=0, tk=null, done=false, started=false;

  function activeLevels(){ var a=[]; CONFIG.levels.forEach(function(c,i){ if(c.on && LEVELS[i]) a.push(i); }); return a; }
  function getShelf(){ try{ return JSON.parse(localStorage.getItem('kk_botshelf_v1')||'[]'); }catch(e){ return []; } }
  function addShelf(i){ var s=getShelf(); if(s.indexOf(i)<0){ s.push(i); try{ localStorage.setItem('kk_botshelf_v1',JSON.stringify(s)); }catch(e){} } }

  function renderShelf(){
    var box=$('kkbab_shelf'); box.querySelectorAll('.kkb-boti').forEach(function(n){n.remove();});
    var s=getShelf();
    CONFIG.levels.forEach(function(c,i){ if(!c.on) return;
      var d=document.createElement('div'); d.className='kkb-boti'+(s.indexOf(i)>=0?' got':'');
      d.textContent = s.indexOf(i)>=0 ? '🤖' : '·'; d.title=c.name; box.appendChild(d); });
    if(activeLevels().length && activeLevels().every(function(i){return s.indexOf(i)>=0;})){
      var b=document.createElement('div'); b.className='kkb-boti badge'; b.textContent='★'; b.title='Master Builder'; box.appendChild(b);
    }
  }
  function renderProg(){
    var p=$('kkbab_prog'); p.innerHTML='';
    activeLevels().forEach(function(idx){ var i=document.createElement('i');
      if(getShelf().indexOf(idx)>=0) i.className='on'; if(idx===li) i.className='cur'; p.appendChild(i); });
  }
  function tick(){ $('kkbab_time').textContent=((Date.now()-t0)/1000).toFixed(1)+'s'; }
  function startClock(){ if(!t0){ t0=Date.now(); tk=setInterval(tick,100); } }
  function svgEl(tag,at){ var e=document.createElementNS(NS,tag); for(var k in at) e.setAttribute(k,at[k]); return e; }
  function shuffle(a){ for(var i=a.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=a[i];a[i]=a[j];a[j]=t; } return a; }

  function load(idx){
    li=idx; lv=LEVELS[idx]; filled=0; wrong=0; t0=0; done=false;
    clearInterval(tk); $('kkbab_time').textContent='0.0s'; $('kkbab_wrong').textContent='0';
    $('kkbab_lvlname').textContent=CONFIG.levels[idx].name;
    $('kkbab_power').style.display='none';
    $('kkbab_msg').textContent='Drag a part from the tray onto a matching dashed slot.'; $('kkbab_msg').className='kkb-msg';
    svg.classList.remove('alive'); svg.innerHTML=''; renderProg();

    var g=svgEl('g',{'class':'kkb-built'}); svg.appendChild(g);
    if(lv.frame) g.appendChild(svgEl('path',{'class':'kkb-fr',d:lv.frame}));
    need=lv.slots.length;
    lv.slots.forEach(function(s){
      var el;
      if(s.kind==='rect') el=svgEl('rect',{'class':'kkb-slot',x:s.x,y:s.y,width:s.w,height:s.h,rx:8});
      else if(s.kind==='circle') el=svgEl('circle',{'class':'kkb-slot',cx:s.x,cy:s.y,r:s.r});
      else el=svgEl('ellipse',{'class':'kkb-slot',cx:s.x,cy:s.y,rx:s.rx,ry:s.ry});
      el.dataset.accept=s.accept; el.dataset.id=s.id; if(s.order!=null) el.dataset.order=s.order;
      s.el=el; g.appendChild(el);
    });
    (lv.eyes||[]).forEach(function(p){ g.appendChild(svgEl('circle',{'class':'kkb-eye',cx:p[0],cy:p[1],r:5})); });
    markNext();

    tray.innerHTML='';
    var items=[];
    (lv.parts||[]).forEach(function(k){ items.push({k:k,decoy:false}); });
    (lv.decoys||[]).forEach(function(k){ items.push({k:k,decoy:true}); });
    shuffle(items).forEach(function(it){
      var c=document.createElement('div'); c.className='kkb-part'+(it.decoy?' decoy':'');
      c.dataset.kind=it.k;
      c.innerHTML='<span class="pic">'+(ICON[it.k]||'▪')+'</span>'+(LABEL[it.k]||it.k);
      tray.appendChild(c); draggable(c,onDrop);
    });
    renderShelf();
  }

  function markNext(){
    svg.querySelectorAll('.kkb-slot.next').forEach(function(n){n.classList.remove('next');});
    if(!lv.order) return;
    lv.slots.forEach(function(s){ if(s.el && +s.el.dataset.order===filled && !s.el.classList.contains('filled')) s.el.classList.add('next'); });
  }

  function onDrop(el,x,y){
    var slot=slotAt(x,y); var kind=el.dataset.kind;
    if(!slot) return false;
    if(slot.classList.contains('filled')){ flash(slot); return false; }
    if(slot.dataset.accept!==kind){
      wrong++; $('kkbab_wrong').textContent=wrong; shake();
      $('kkbab_msg').textContent = el.classList.contains('decoy') ? 'That’s not a robot part — leave the decoys in the tray.' : 'Wrong slot for that part. Look at the shape.';
      $('kkbab_msg').className='kkb-msg bad'; tone(90,.22,'sawtooth'); return false;
    }
    if(lv.order && +slot.dataset.order!==filled){
      wrong++; $('kkbab_wrong').textContent=wrong; shake();
      $('kkbab_msg').textContent='Build from the base up — that piece comes later.'; $('kkbab_msg').className='kkb-msg bad'; tone(120,.2,'sawtooth');
      return false;
    }
    startClock();
    slot.classList.add('filled'); slot.classList.remove('next','over');
    var b = slot.getBBox ? slot.getBBox() : {x:+slot.getAttribute('cx')-10,y:+slot.getAttribute('cy')-10,width:20,height:20};
    var t=svgEl('text',{'class':'kkb-tick',x:b.x+b.width/2,y:b.y+b.height/2}); t.textContent='✓';
    slot.parentNode.appendChild(t);
    filled++; tone(440+filled*70,.09,'square');
    $('kkbab_msg').textContent=filled+' / '+need+' parts in place.'; $('kkbab_msg').className='kkb-msg good';
    markNext();
    if(filled===need) finishBuild();
    return true;
  }
  function flash(s){ s.classList.add('over'); setTimeout(function(){s.classList.remove('over');},200); }
  function shake(){ if(reduce) return; svg.animate([{transform:'translateX(-4px)'},{transform:'translateX(4px)'},{transform:'translateX(0)'}],{duration:150,iterations:2}); }

  function finishBuild(){
    clearInterval(tk);
    if(lv.power){ $('kkbab_power').style.display=''; $('kkbab_msg').textContent='Frame complete. Hit Power on.'; $('kkbab_msg').className='kkb-msg'; return; }
    boot();
  }
  $('kkbab_power').onclick=function(){ this.style.display='none'; boot(); };

  function boot(){
    if(done) return; done=true;
    svg.classList.add('alive');
    tone(392,.1,'triangle'); setTimeout(function(){tone(587,.14,'triangle');},150);
    var secs=(Date.now()-t0)/1000, c=CONFIG.levels[li];
    var t2=(c.t3||20)*2.2;
    var stars = (secs<=(c.t3||20) && wrong===0) ? 3 : (secs<=t2 && wrong<=2) ? 2 : 1;
    addShelf(li); renderShelf(); renderProg();
    setTimeout(function(){ showWin(stars); chord(); burst(stars*12); }, 700);
  }

  var MODE = CONFIG.rewardMode || 'code';

  function isLastLevel(levelIdx){ var a=activeLevels(); return a.indexOf(levelIdx) === a.length-1; }

  function rewardForLevel(levelIdx){
    var fr = CONFIG.finalReward || {};
    if(MODE === 'code'){
      // per-level codes, if any tier is configured
      var pos = activeLevels().indexOf(levelIdx)+1, t=null;
      (CONFIG.tiers||[]).forEach(function(x){ if(x.after===pos && x.code && String(x.code).trim()) t=x; });
      if(t) return t;
      // otherwise: one code, shown only after the final build
      if(isLastLevel(levelIdx) && fr.enabled !== false && fr.code && String(fr.code).trim()){
        return { label: fr.label, code: fr.code };
      }
      return null;
    }
    // claim / demo: ONE reward, only when the final build is done
    if(isLastLevel(levelIdx) && fr.enabled !== false && fr.label && String(fr.label).trim()){
      return { label: fr.label, code: null };
    }
    return null;
  }

  function showWin(stars){
    var lastOne = isLastLevel(li);
    $('kkbab_ovstars').textContent='★★★☆☆'.slice(3-stars,6-stars);
    $('kkbab_ovh').textContent = lastOne ? 'All builds complete! 🏆' : (CONFIG.levels[li].name + ' assembled!');
    $('kkbab_ovp').textContent = lastOne ? 'That’s every bot on the shelf. You’ve earned this.' :
      stars===3 ? 'Flawless — no misfits, fast hands.' :
      stars===2 ? 'Built and booting. Cleaner next time for three stars.' : 'It lives! Fewer misfits next run.';
    var rw=$('kkbab_ovreward');
    if(lastOne && (CONFIG.finalReward||{}).enabled !== false){
      // Final build done: hand off to the site-wide LED-pack reward - same
      // claim popup (real email/mobile capture, free LED pack auto-added to
      // cart) used by the other Kit Shelf games, instead of a discount code.
      rw.style.display='none';
      try { document.dispatchEvent(new CustomEvent("kk:game-won", { detail: { game: "build-a-bot" } })); } catch(e) {}
    } else {
      var tier=rewardForLevel(li);
      if(tier){ rw.style.display=''; setupReward(tier); }
      else { rw.style.display='none'; }
    }
    var ul=$('kkbab_ovbomlist'); ul.innerHTML='';
    (lv.bom||[]).forEach(function(x){ var el=document.createElement('li'); el.textContent=x; ul.appendChild(el); });
    var shop=$('kkbab_ovshop'), colUrl=(CONFIG.levels[li]||{}).collection;
    if(colUrl){ shop.style.display=''; shop.href=colUrl; } else { shop.style.display='none'; }
    var act=activeLevels(), pos=act.indexOf(li);
    $('kkbab_ovnext').textContent = pos < act.length-1 ? 'Next build →' : 'Back to first build ↺';
    $('kkbab_ov').classList.add('show');
  }
  /* ---- reward delivery (code / claim-by-email / demo) ---- */
  function show(id,on){ var e=$(id); if(e) e.style.display = on ? '' : 'none'; }
  function setupReward(tier){
    $('kkbab_ovrewardlab').textContent = tier.label || 'Reward unlocked';
    show('kkbab_claim_start', false); show('kkbab_claim_form', false);
    show('kkbab_claim_result', false); show('kkbab_code_view', false);
    var f=$('kkbab_claim_fine'); if(f){ f.textContent=''; f.className='kkb-claim-fine'; }

    if(MODE === 'code'){
      showCode(tier.code, tier.code);
      return;
    }
    // claim / demo
    $('kkbab_claim_sub').textContent = CONFIG.claimSub || 'Enter your email and we’ll send your one-time code.';
    show('kkbab_claim_start', true);
    $('kkbab_claim_btn').onclick = function(){ show('kkbab_claim_start', false); show('kkbab_claim_form', true); $('kkbab_claim_email').focus(); };
    $('kkbab_claim_form').onsubmit = function(e){ e.preventDefault(); submitClaim(tier); };
  }
  function showCode(code, applyCode){
    show('kkbab_code_view', true);
    $('kkbab_ovrewardcode').textContent = code;
    var apply=$('kkbab_ovapply');
    apply.href = DISCOUNT_BASE + 'discount/' + encodeURIComponent(applyCode || code);
    $('kkbab_ovcopy').onclick = function(){ try{ navigator.clipboard.writeText(code); }catch(e){} this.textContent='Copied ✓'; };
  }
  function claimResult(html){ var r=$('kkbab_claim_result'); r.innerHTML=html; show('kkbab_claim_result', true); }
  function fineErr(msg){ var f=$('kkbab_claim_fine'); f.textContent=msg; f.className='kkb-claim-fine err'; }

  function submitClaim(tier){
    var email = ($('kkbab_claim_email').value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ fineErr('That email doesn’t look right.'); return; }
    var btn=$('kkbab_claim_send'); btn.disabled=true; btn.textContent='Sending…';
    var validity = CONFIG.validityText || '48 hours';
    var cond = CONFIG.minOrderText ? ' ' + CONFIG.minOrderText + '.' : '';

    if(MODE === 'demo'){
      setTimeout(function(){
        var demoCode='BAB'+Math.random().toString(36).slice(2,8).toUpperCase();
        show('kkbab_claim_form', false);
        claimResult('Demo: your code <b>'+demoCode+'</b> would be emailed to <b>'+esc(email)+'</b>.<br>Valid '+validity+'.'+cond+' (No real email sent — this is the demo mode.)');
      }, 500);
      return;
    }

    // real claim
    var url = CONFIG.claimEndpoint;
    if(!url){ show('kkbab_claim_form',false); claimResult('Rewards service isn’t configured yet. Please try again later.'); return; }
    fetch(url, { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ email: email, tier: tier.label || '', level: (CONFIG.levels[li]||{}).name || '' }) })
    .then(function(r){ return r.json().catch(function(){ return {status:'error'}; }); })
    .then(function(d){
      show('kkbab_claim_form', false);
      if(d.status === 'sent'){
        claimResult('Your code is on its way to <b>'+esc(email)+'</b>. Check your inbox (and spam). Valid '+validity+'.'+cond);
      } else if(d.status === 'issued'){
        claimResult('Here’s your one-time code — valid '+validity+'.'+cond);
        showCode(d.code, d.code);
      } else if(d.status === 'returning'){
        claimResult(esc(CONFIG.returningMsg || 'You’ve already claimed your maker discount.'));
      } else if(d.status === 'invalid_email'){
        show('kkbab_claim_form', true); btn.disabled=false; btn.textContent='Send my code';
        fineErr(d.reason === 'disposable' ? 'Please use a real inbox — temp emails aren’t accepted.' : 'That email doesn’t look right.');
      } else if(d.status === 'rate_limited'){
        claimResult('Too many attempts from this connection. Take a break and try again later.');
      } else {
        show('kkbab_claim_form', true); btn.disabled=false; btn.textContent='Try again';
        fineErr('Couldn’t reach the rewards desk. Try again in a moment.');
      }
    })
    .catch(function(){
      show('kkbab_claim_form', true); btn.disabled=false; btn.textContent='Try again';
      fineErr('Network hiccup — try again in a moment.');
    });
  }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  $('kkbab_ovnext').onclick=function(){
    $('kkbab_ov').classList.remove('show');
    var act=activeLevels(), pos=act.indexOf(li);
    load(pos < act.length-1 ? act[pos+1] : act[0]);
  };
  $('kkbab_reset').onclick=function(){ load(li); };

  document.documentElement.style && root.style.setProperty('--kkb-accent', CONFIG.accent || '#ffab1a');
  renderShelf(); renderProg();
  var act=activeLevels();
  load(act.length ? act[0] : 0);
})();
